export class ArticlePrepareData {
    public vectorId: number = -1;
    public givingConnectionNames: string[];

    public constructor(vectorId: number, givingConnectionNames: string[]) {
        this.vectorId = vectorId;
        this.givingConnectionNames = givingConnectionNames;
    }
}

